import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Box, Typography, Button, CircularProgress } from '@mui/material';
import { COLORS } from '../../shared/colors';

const CommonFormModal = ({
  open,
  onClose,
  title,
  subtitle,
  onSubmit,
  submitLabel,
  cancelLabel = 'Cancel',
  isSubmitting = false,
  isSubmitDisabled = false,
  maxWidth = 'md', // Ignored if width override is active, but kept for fallback
  customWidth = '786px',
  children
}) => {
  return (
    <Dialog 
      open={open} 
      onClose={isSubmitting ? null : onClose} 
      maxWidth={maxWidth}
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          width: `min(${customWidth}, calc(100vw - 32px))`,
          maxWidth: 'none',
          borderRadius: '8px',
          border: `2px solid ${COLORS.brand.primaryDark}`,
          boxShadow: '0 16px 40px rgba(8, 43, 114, 0.22)',
          overflow: 'hidden'
        }
      }}
    >
      <DialogTitle className="pm-dialog-title" sx={{ pb: { xs: '0px !important', lg: 1 }, position: 'relative' }}>
        <Box className="pm-dialog-header">
          <Typography className="pm-dialog-heading">
            {title}
          </Typography>
          {subtitle && (
            <Typography className="pm-dialog-subheading">
              {subtitle}
            </Typography>
          )}
        </Box>
      </DialogTitle>

      <DialogContent className="pm-dialog-content" sx={{ px: '1.5rem', pt: { xs: '0px !important', lg: '1rem' }, pb: '0.75rem' }}>
        <Box component="form" onSubmit={onSubmit} noValidate>
          {children}
        </Box>
      </DialogContent>

      <DialogActions 
        className="pm-dialog-actions" 
        sx={{ 
          px: '32px', 
          pt: 1.5, 
          pb: 3, 
          justifyContent: 'space-between', 
          gap: 2, 
          '& > :not(style) ~ :not(style)': { ml: 0 } 
        }}
      >
        <Button 
          onClick={onClose} 
          variant="outlined" 
          disabled={isSubmitting}
          sx={{ 
            minWidth: 150, 
            px: 4, 
            py: 1, 
            borderRadius: '6px', 
            borderColor: COLORS.ui.border, 
            color: COLORS.pureBlack, 
            fontSize: '0.9rem', 
            fontWeight: 600, 
            textTransform: 'none', 
            '&:hover': { borderColor: COLORS.gray[400], bgcolor: COLORS.gray[50] } 
          }}
        >
          {cancelLabel}
        </Button>
        <Button
          variant="contained"
          onClick={onSubmit}
          disabled={isSubmitDisabled || isSubmitting}
          startIcon={isSubmitting ? <CircularProgress size={18} color="inherit" /> : null}
          sx={{ 
            minWidth: 160, 
            px: 4, 
            py: 1, 
            borderRadius: '6px', 
            bgcolor: COLORS.brand.primaryDark, 
            color: COLORS.white, 
            fontSize: '0.9rem', 
            fontWeight: 600, 
            textTransform: 'none', 
            '&:hover': { bgcolor: COLORS.brand.primaryDarkHover },
            '&.Mui-disabled': { bgcolor: COLORS.gray[200], color: COLORS.gray[500] }
          }}
        >
          {isSubmitting ? 'Saving...' : submitLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CommonFormModal;
